import gql from 'graphql-tag';

export default gql`
fragment TimetableTimeSlotAllData on TimetableTimeSlot {
    id
    sector {
        id
        name
    }
    order_limit
    weight_limit
    price
    range_date
    timeRange {
        id
        time_from
        time_to
    }
    visible_until
    status
    reserved_order_count
    reserved_weight_count
    orders {
        id
        shipping_postcode
        status {
            code
        }
        parent_order {
            id
        }
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/TimetableTimeSlotAllData.ts